// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1800px) {
  .dash_user_sec {
    flex-wrap: nowrap;
  }
}

/* \`xxl\` applies to x-large devices (large desktops, less than 1400px) */
@media (max-width: 1600px) {
  .owner_login {
    height: auto;
  }
  .right-side {
    height: auto;
  }
}

/* \`xl\` applies to large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
  .owner_login {
    height: auto;
  }
  .right-side {
    height: auto;
  }
}

/* \`lg\` applies to medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .owner_login {
    display: flex;
    flex-direction: column;
    height: auto;
  }
  .left-side,
  .right-side {
    width: 100%;
  }
  .left_content {
    padding: 20px;
  }
}

/* \`md\` applies to small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
  .login_wrap {
    max-width: 100%;
    min-height: auto;
    display: flex;
    flex-direction: column;
  }
  .login_content {
    max-width: 100%;
    width: 100%;
    border-left: 0;
    padding: 10px;
  }
}

@media (max-width: 575.98px) {
  .heading_content h3 {
    font-size: 18px;
  }
  .name_account .form-label {
    font-size: 18px;
  }
  .item_box p {
    font-size: 14px;
  }
  .item_box.active,
  .item_box:hover {
    padding: 10px;
  }
  .profile__tab {
    margin-bottom: 20px;
  }
  .profile__tab .nav-pills a {
    max-width: 100%;
  }
  .profile__content {
    padding: 0px 10px;
  }
}

/* //add new css after testing @responsive */

@media (min-width: 1800px) {
  .dash_user_sec {
    flex-wrap: nowrap;
  }
}

/* \`xxl\` applies to x-large devices (large desktops, less than 1400px) */
@media (max-width: 1600px) {
  .owner_login {
    height: auto;
  }
  .right-side {
    height: auto;
  } .user_chat {
    min-width:auto  !important;
  }
}

/* \`xl\` applies to large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
  .owner_login {
    height: auto;
  }
  .right-side {
    height: auto;
  }
}

/* \`lg\` applies to medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .owner_login {
    display: flex;
    flex-direction: column;
    height: auto;
  }
  .left-side,
  .right-side {
    width: 100%;
  }
  .left_content {
    padding: 20px;
  }
}

/* \`md\` applies to small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
  .login_wrap {
    max-width: 100%;
    min-height: auto;
    display: flex;
    flex-direction: column;
  }
  .login_content {
    max-width: 100%;
    width: 100%;
    border-left: 0;
    padding: 10px 10px 10px 0;
  }
}

@media (max-width: 575.98px) {
  .heading_content h3 {
    font-size: 18px;
  }
  .name_account .form-label {
    font-size: 18px;
  }
  .item_box p {
    font-size: 14px;
  }
  .item_box.active,
  .item_box:hover {
    padding: 10px;
  }
  .profile__tab {
    margin-bottom: 20px;
  }
  .profile__tab .nav-pills a {
    max-width: 100%;
  }
  .profile__content {
    padding: 0px 10px;
  }
}
/* add some css  make for responsive seema */
@media only screen and (min-width: 310px) and (max-width: 525px) {
  .direction_f {
    flex-direction: column;
  }
  .gen_btn {
    width: 100% !important;
  }
}
@media only screen and (min-width: 310px) and (max-width: 425px) {
  .btns_section {
    gap: 4px !important;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding-top: 8px !important;
  }
  .date-picker-container {
    margin: 4px !important;
  }
  .form_f {
    margin: 4px;
    width: 100%;
  }
  .align-items-baseline {
    margin: 4px !important;
    width: 100% !important;
    padding-top: 5px !important;
    flex-wrap: nowrap;
  }
}

@media only screen and (min-width: 310px) and (max-width: 991px) {
  .btns_section {
    gap: 4px !important;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding-top: 5px !important;
  }
}

@media (max-width: 991.98px) {
  .owner_login {
    display: flex;
    flex-direction: column;
    height: auto;
  }
  .left-side,
  .right-side {
    width: 100%;
  }
  .left_content {
    padding: 20px;
  }
  .active_header {
    display: flex !important;
    flex-direction: row;
    height: unset !important;
    justify-content: space-between;
    width: 100% !important;
    padding: 0px 10px !important;
  }
  .notification-wrapper {
    position: relative;
    display: flex;
    flex-direction: row !important;
    min-width: 100px;
    align-items: center;
    gap: 5px;
  }
  .navbar-nav .dropdown-menu {
    position: absolute !important;
  }
  .dropdown-menu.show {
    top: 0;
    left: 0;
    transform: translate(-60%, 0%);
    min-height: 40px !important;
    min-width: 86px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/agentpanel/styles/agent-responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,4CAA4C;;AAE5C;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd,EAAE;IACA,0BAA0B;EAC5B;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;AACA,4CAA4C;AAC5C;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,MAAM;IACN,OAAO;IACP,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF","sourcesContent":["@media (min-width: 1800px) {\n  .dash_user_sec {\n    flex-wrap: nowrap;\n  }\n}\n\n/* `xxl` applies to x-large devices (large desktops, less than 1400px) */\n@media (max-width: 1600px) {\n  .owner_login {\n    height: auto;\n  }\n  .right-side {\n    height: auto;\n  }\n}\n\n/* `xl` applies to large devices (desktops, less than 1200px) */\n@media (max-width: 1199.98px) {\n  .owner_login {\n    height: auto;\n  }\n  .right-side {\n    height: auto;\n  }\n}\n\n/* `lg` applies to medium devices (tablets, less than 992px) */\n@media (max-width: 991.98px) {\n  .owner_login {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n  }\n  .left-side,\n  .right-side {\n    width: 100%;\n  }\n  .left_content {\n    padding: 20px;\n  }\n}\n\n/* `md` applies to small devices (landscape phones, less than 768px) */\n@media (max-width: 767.98px) {\n  .login_wrap {\n    max-width: 100%;\n    min-height: auto;\n    display: flex;\n    flex-direction: column;\n  }\n  .login_content {\n    max-width: 100%;\n    width: 100%;\n    border-left: 0;\n    padding: 10px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .heading_content h3 {\n    font-size: 18px;\n  }\n  .name_account .form-label {\n    font-size: 18px;\n  }\n  .item_box p {\n    font-size: 14px;\n  }\n  .item_box.active,\n  .item_box:hover {\n    padding: 10px;\n  }\n  .profile__tab {\n    margin-bottom: 20px;\n  }\n  .profile__tab .nav-pills a {\n    max-width: 100%;\n  }\n  .profile__content {\n    padding: 0px 10px;\n  }\n}\n\n/* //add new css after testing @responsive */\n\n@media (min-width: 1800px) {\n  .dash_user_sec {\n    flex-wrap: nowrap;\n  }\n}\n\n/* `xxl` applies to x-large devices (large desktops, less than 1400px) */\n@media (max-width: 1600px) {\n  .owner_login {\n    height: auto;\n  }\n  .right-side {\n    height: auto;\n  } .user_chat {\n    min-width:auto  !important;\n  }\n}\n\n/* `xl` applies to large devices (desktops, less than 1200px) */\n@media (max-width: 1199.98px) {\n  .owner_login {\n    height: auto;\n  }\n  .right-side {\n    height: auto;\n  }\n}\n\n/* `lg` applies to medium devices (tablets, less than 992px) */\n@media (max-width: 991.98px) {\n  .owner_login {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n  }\n  .left-side,\n  .right-side {\n    width: 100%;\n  }\n  .left_content {\n    padding: 20px;\n  }\n}\n\n/* `md` applies to small devices (landscape phones, less than 768px) */\n@media (max-width: 767.98px) {\n  .login_wrap {\n    max-width: 100%;\n    min-height: auto;\n    display: flex;\n    flex-direction: column;\n  }\n  .login_content {\n    max-width: 100%;\n    width: 100%;\n    border-left: 0;\n    padding: 10px 10px 10px 0;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .heading_content h3 {\n    font-size: 18px;\n  }\n  .name_account .form-label {\n    font-size: 18px;\n  }\n  .item_box p {\n    font-size: 14px;\n  }\n  .item_box.active,\n  .item_box:hover {\n    padding: 10px;\n  }\n  .profile__tab {\n    margin-bottom: 20px;\n  }\n  .profile__tab .nav-pills a {\n    max-width: 100%;\n  }\n  .profile__content {\n    padding: 0px 10px;\n  }\n}\n/* add some css  make for responsive seema */\n@media only screen and (min-width: 310px) and (max-width: 525px) {\n  .direction_f {\n    flex-direction: column;\n  }\n  .gen_btn {\n    width: 100% !important;\n  }\n}\n@media only screen and (min-width: 310px) and (max-width: 425px) {\n  .btns_section {\n    gap: 4px !important;\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    padding-top: 8px !important;\n  }\n  .date-picker-container {\n    margin: 4px !important;\n  }\n  .form_f {\n    margin: 4px;\n    width: 100%;\n  }\n  .align-items-baseline {\n    margin: 4px !important;\n    width: 100% !important;\n    padding-top: 5px !important;\n    flex-wrap: nowrap;\n  }\n}\n\n@media only screen and (min-width: 310px) and (max-width: 991px) {\n  .btns_section {\n    gap: 4px !important;\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    padding-top: 5px !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .owner_login {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n  }\n  .left-side,\n  .right-side {\n    width: 100%;\n  }\n  .left_content {\n    padding: 20px;\n  }\n  .active_header {\n    display: flex !important;\n    flex-direction: row;\n    height: unset !important;\n    justify-content: space-between;\n    width: 100% !important;\n    padding: 0px 10px !important;\n  }\n  .notification-wrapper {\n    position: relative;\n    display: flex;\n    flex-direction: row !important;\n    min-width: 100px;\n    align-items: center;\n    gap: 5px;\n  }\n  .navbar-nav .dropdown-menu {\n    position: absolute !important;\n  }\n  .dropdown-menu.show {\n    top: 0;\n    left: 0;\n    transform: translate(-60%, 0%);\n    min-height: 40px !important;\n    min-width: 86px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
